"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicTheme = exports.getPublicThemes = exports.deleteThemeRelation = exports.postThemeRelation = exports.putThemeOrganization = exports.putThemeAccessibility = exports.deleteThemePermission = exports.postThemePermission = exports.delTheme = exports.postTheme = exports.putTheme = exports.getTheme = exports.getThemes = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var themesAuthorizedPath = root_1.cmsAuthorized + '/themes/';
var themesPublicPath = root_1.cmsPublic + '/themes/';

var getThemes = function getThemes(authentication, queryParameters) {
  return common_1.get(authentication, themesAuthorizedPath, queryParameters);
};

exports.getThemes = getThemes;

var getTheme = function getTheme(authentication, id) {
  return common_1.get(authentication, themesAuthorizedPath + id);
};

exports.getTheme = getTheme;

var putTheme = function putTheme(authentication, theme) {
  return common_1.put(authentication, themesAuthorizedPath + theme.id, theme);
};

exports.putTheme = putTheme;

var postTheme = function postTheme(authentication, theme) {
  return common_1.post(authentication, themesAuthorizedPath, theme);
};

exports.postTheme = postTheme;

var delTheme = function delTheme(authentication, id) {
  return common_1.del(authentication, themesAuthorizedPath + id);
};

exports.delTheme = delTheme;

var postThemePermission = function postThemePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, themesAuthorizedPath, id, permission);
};

exports.postThemePermission = postThemePermission;

var deleteThemePermission = function deleteThemePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, themesAuthorizedPath, id, permissionId);
};

exports.deleteThemePermission = deleteThemePermission;

var putThemeAccessibility = function putThemeAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, themesAuthorizedPath, id, accessibility);
};

exports.putThemeAccessibility = putThemeAccessibility;

var putThemeOrganization = function putThemeOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, themesAuthorizedPath, id, organizationId);
};

exports.putThemeOrganization = putThemeOrganization;

var postThemeRelation = function postThemeRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, themesAuthorizedPath, id, relation);
};

exports.postThemeRelation = postThemeRelation;

var deleteThemeRelation = function deleteThemeRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, themesAuthorizedPath, id, relationId);
};

exports.deleteThemeRelation = deleteThemeRelation;

var getPublicThemes = function getPublicThemes(authentication, queryParameters) {
  return common_1.get(authentication, themesPublicPath, queryParameters);
};

exports.getPublicThemes = getPublicThemes;

var getPublicTheme = function getPublicTheme(authentication, id) {
  return common_1.get(authentication, themesPublicPath + id);
};

exports.getPublicTheme = getPublicTheme;